import { render } from "./PhoneVisualConditionOther.vue?vue&type=template&id=1872d3b0"
import script from "./PhoneVisualConditionOther.vue?vue&type=script&lang=js"
export * from "./PhoneVisualConditionOther.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__